<template>
  <div class="main">
    <div class="main_right">
      <div class="page_info">
        <Breadcrumb class="breadcrumb">
          <BreadcrumbItem>设备查询</BreadcrumbItem>
        </Breadcrumb>
        <div class="dev_data">
          <div>
            <Input v-model="deviceNo" icon="ios-search" placeholder="请输入设备编号" style="width: 400px;margin-left: 60px;" @on-click="search" @keyup.13.native="search"/>
          </div>
          <div class="dev_line">
            <div class="dev_title">设备编号：</div>
            <div>{{deviceInfo.deviceNo || '无'}}</div>
          </div>
          <div class="dev_line">
            <div class="dev_title">机具状态：</div>
            <div>{{deviceInfo.status || '无'}}</div>
          </div>
          <div class="dev_line">
            <div class="dev_title">Isv_pid：</div>
            <div>{{deviceInfo.isvPid || '无'}}</div>
          </div>
          <div class="dev_line">
            <div class="dev_title">机具绑定状态 ：</div>
            <div>{{deviceInfo.bindStatus || '无'}}</div>
          </div>
          <div class="dev_line">
            <div class="dev_title">商户id：</div>
            <div>{{deviceInfo.merchantPid || '无'}}</div>
          </div>
          <div class="dev_line">
            <div class="dev_title">门店id：</div>
            <div>{{deviceInfo.shopId || '无'}}</div>
          </div>
          <div class="dev_line">
            <div class="dev_title">物料id：</div>
            <div>{{deviceInfo.itemId || '无'}}</div>
          </div>
          <div class="dev_line">
            <div class="dev_title">供应商id：</div>
            <div>{{deviceInfo.supplierSn || '无'}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {httpUrl} from '../../api/index'
import TopOpe from '../top-ope/top-ope'
import {errorHandler} from '../../util/errorHandler'
// import {nSuccess, nError} from '../../util/notice'
// import {pattern} from '../../util/regular'
// import md5 from 'js-md5'

export default {
  components: {TopOpe},
  name: 'query-device',
  data () {
    return {
      deviceInfo: {},
      deviceNo: ''
    }
  },
  methods: {
    search () {
      this.$axios.post(`${httpUrl.url}/manage/alipayDevice/getDeviceInfo/${this.deviceNo}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            this.deviceInfo = res.data.data
          }
        })
        .catch(errorHandler('查询失败'))
    }
  }
}
</script>

<style scoped>
  .main {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }

  .main_right {
    width: 100%;
    height: 100%;
  }

  .breadcrumb {
    margin-bottom: 10px;
    border-left: 3px solid #00A0E6;
    padding-left: 5px;
  }
  .page_info {
    margin: 15px;
    background-color: #fff;
  }

  .dev_data {
    width: 80%;
    margin: 40px auto;
  }

  .dev_line {
    margin: 10px;
    display: flex;
    justify-content: flex-start;
    line-height: 30px;
  }

  .dev_title {
    width: 120px;
    text-align: right;
  }

  .line_name {
    display: inline-block;
    width: 60px;
    text-align: right;
  }

  .btn button {
    margin: 30px 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/query-device/query-device.vue